import moment, { Moment } from "moment";
import { DataHelper } from "./data-helper";

export class TaskBusinessHelper {
  //# search wiki: How+to+detect+region+base+on+postcode
  //# search wiki: Property+Finance+Tab+-+Data+and+Calculator
  static getDateDuration(time, unit) {
    let today = moment();    
    let toDate = moment(today).add(time, unit);
    let fromDate = moment(today).add(-time, unit);

    return {
      ToDate: toDate,
      FromDate: fromDate
    }    
  }

  static getDateDurationFromCombox(value) {
    let duration: any;
    switch (value) {
      case 0:
        duration = this.getDateDuration('1', 'week');
        break;
      case 1:
        duration = this.getDateDuration('2', 'weeks');
        break;
      case 2:
        duration = this.getDateDuration('1', 'month');
        break;
      case 3:
        duration = this.getDateDuration('2', 'months');
        break;
      case 4:
        duration = this.getDateDuration('1', 'year');
        break;
      case 5:
        duration = this.getDateDuration('2', 'year');
        break;
      case 6:
        duration = this.getDateDuration('3', 'year');
        break;
      case 7:
        duration = this.getDateDuration('4', 'year');
        break;
      case 8:
        duration = this.getDateDuration('5', 'year');
        break;
      case 9:
        duration = this.getDateDuration('10', 'year');
        break;
      default:
        duration = null;
        break;
    }

    return duration;
  }

  static getDurationIndex(fromDate: Moment, toDate: Moment) {
    let duration: any;
    let result: number = null;
    for (let index = 0; index < 10; index++) {
      duration = this.getDateDurationFromCombox(index);
      if(duration !== null 
        && DataHelper.formatDate(duration.FromDate) === DataHelper.formatDate(fromDate) 
        && DataHelper.formatDate(duration.ToDate) === DataHelper.formatDate(toDate)) {
          return index;
        }
        
    }
    return result;
  }
}
